import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Utils} from '../../../../../common/services/Utils';
import {LangChange} from '../../../../../lang-change';
import {Language} from '../../../../../common/models/language';
import {GraduateRegisterService} from '../../../../shared/services/graduate-register.service';
import {DictionaryService} from '../../../../shared/services/dictionary.service';
import {EdsService} from '../../../../shared/services/eds.service';

@Component({
  selector: 'app-register-graduate-action-dialog',
  templateUrl: './register-graduate-action-dialog.component.html',
  styleUrls: ['./register-graduate-action-dialog.component.scss']
})
export class RegisterGraduateActionDialogComponent extends LangChange implements OnInit {

  graduateDto;
  type = 'UPDATE';
  options = {};
  isDisabled = true;
  selectedFile = {};

  constructor(public _dialogRef: MatDialogRef<RegisterGraduateActionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _registerService: GraduateRegisterService,
              private _dictionaryService: DictionaryService,
              private _edsService: EdsService,
              private _utils: Utils) {
    super(_utils._translateService);
    console.log('RegisterGraduateActionDialogComponent', data)
    this.graduateDto = data.graduateDto;
    this.type = data.graduateDto.type;
    this.graduateDto.incorrectIin = !(this.type == 'UPDATE' && this.graduateDto.iin != null && this.graduateDto.iin.length == 12);
    // this.data.centerProfessionList = data.centerProfessionList;
  }

  ngOnInit() {

    this.options['UPDATE'] = {
      page_title: 'register.application_correction_data_in_register'
    };

    this.options['INSERT'] = {
      page_title: 'register.application_insert_data_in_register'
    };

    this.isDisabled = this.type === 'UPDATE';

    if (this.type === 'UPDATE') {
      if (this.graduateDto.degreeId > 0) {
        this.data.degreeList = this._utils.translateListWithSort([this.graduateDto.degreeDto], 'name');
      }

      if (!this.graduateDto.centerProfessionChecked) {
        this.data.centerProfessionList = [];
        if (this.graduateDto.professionDto) {
          this.data.centerProfessionList = this.translateProfessionList([this.graduateDto.professionDto]);
        } else {
          this.graduateDto.professionId = null;
        }
      }

    } else {
      this._dictionaryService.getAcademicDegreeList().subscribe(list => {
        this.data.degreeList = this._utils.translateListWithSort(list, 'name');
      });

      this._dictionaryService.getSexList().subscribe(list => {
        this.data.sexList = this._utils.translateListWithSort(list, 'name');
      });

      this.changeUniversity();
    }
  }

  changeUniversity() {
    if (this.graduateDto.collegeId > 0) {
      this._dictionaryService.getUniversityNationalityDictList(this.graduateDto.collegeId).subscribe(list => {
        this.data.nationalityList = this._utils.translateListWithSort(list, 'name');
      });
    }
  }

  onLangChange(language: Language): void {
    this.data.centerProfessionList = this.translateProfessionList(this.data.centerProfessionList);
    if (this.data.nationalityList) {
      this.data.nationalityList = this._utils.translateListWithSort(this.data.nationalityList, 'name');
    }

    if (this.data.degreeList) {
      this.data.degreeList = this._utils.translateListWithSort(this.data.degreeList, 'name');
    }

  }


  translateProfessionList(list) {
    for (let i = 0; i < list.length; i++) {
      list[i].fullName = list[i].code + ' ' + this._utils.getMultiValue(list[i], 'name');
    }
    return list.sort((a, b) => a.fullName.localeCompare(b.fullName));
  }

  onSave(invalid) {
    if (invalid) {
      return;
    }


    this._edsService.signXmlCall('<data></data>', (signedXml) => {
      if (signedXml) {
        this.graduateDto.signedXml = signedXml;

        if (this.type == 'INSERT') {
          this.createRequestForInsert();
          return;
        }
        const requestDto = {
          iin: this.graduateDto.iin,
          incorrectIin: this.graduateDto.incorrectIin,
          graduateId: this.graduateDto.graduateId,
          collegeId: this.graduateDto.collegeId,
          lastName: this.graduateDto.lastName,
          firstName: this.graduateDto.firstName,
          patronymic: this.graduateDto.patronymic,
          email: this.graduateDto.email,
          mobilePhone: this.graduateDto.mobilePhone,
          content: this.graduateDto.content,
          signedXml: this.graduateDto.signedXml,
        };

        const fd = new FormData();
        fd.append('jsonDto', JSON.stringify(requestDto));

        if (this.selectedFile && this.selectedFile['icFiles']) {
          for (const i in this.selectedFile['icFiles']) {
            fd.append('icFiles', this.selectedFile['icFiles'][i], this.selectedFile['icFiles'][i]['name']);
          }
        }

        this._utils.blockStart(null);
        this._registerService.createRequestApplication(this.type, fd).subscribe(resp => {
            this._utils.blockStop();
            this._utils.notifyMessage(resp, succ => {
              this._dialogRef.close(true);
            }, null);
          },
          error => {
            this._utils.notifyError('error_occurred', null);
            this._utils.blockStop();
          });
      }
    });
  }

  private createRequestForInsert() {
    const fd = new FormData();
    fd.append('jsonDto', JSON.stringify(this.graduateDto));

    // for (const i in this.selectedFile['diplomaScan']) {
    fd.append('diplomaScan', this.selectedFile['diplomaScan'], this.selectedFile['diplomaScan']['name']);
    // }

    for (const i in this.selectedFile['diplomaApplication']) {
      fd.append('diplomaApplication', this.selectedFile['diplomaApplication'][i], this.selectedFile['diplomaApplication'][i]['name']);
    }

    for (const i in this.selectedFile['icFiles']) {
      fd.append('icFiles', this.selectedFile['icFiles'][i], this.selectedFile['icFiles'][i]['name']);
    }


    this._utils.blockStart(null);
    this._registerService.createRequestApplication(this.type, fd).subscribe(resp => {
        this._utils.blockStop();
        this._utils.notifyMessage(resp, succ => {
          this._dialogRef.close(true);
        }, null);
      },
      error => {
        this._utils.notifyError('error_occurred', null);
        this._utils.blockStop();
      });
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this._dialogRef.close();
  }

  closeDialog(): void {
    this._dialogRef.close();
  }

  fileChange(event, attr) {
    const fileList: FileList[] = event.target.files;
    if (!fileList || !fileList.length) {
      this.selectedFile[attr] = null;
      return;
    }

    if (attr == 'diplomaApplication' || attr == 'icFiles') {
      this.selectedFile[attr] = [];
      this.selectedFile[attr].push(...fileList);
    } else {
      this.selectedFile[attr] = fileList[0];
    }
    event.target.value = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/register/register-graduate-action-dialog/register-graduate-action-dialog.component.ts